"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discrete = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const react_1 = require("react");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_form_search_1 = require("@dzambalaorg/mui-form-search");
const mui_dialog_delete_1 = require("@dzambalaorg/mui-dialog-delete");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../../../../types");
const inputs_1 = require("../../../../../inputs");
const dialogs_1 = require("../../../../../dialogs");
const schemas_1 = require("./schemas");
const validation_1 = require("./form/validation");
const DISCRETE_URL = "/discrete";
const emptyValues = {
    contractId: 0,
    attribute: "",
    discreteStatus: types_1.DiscreteStatus.ACTIVE,
    discreteStrategy: types_1.DiscreteStrategy.FLAT,
    growthRate: 0,
    price: mui_inputs_asset_1.emptyPrice,
};
const Discrete = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return {
            discreteStatus: [types_1.DiscreteStatus.ACTIVE],
            ...(service === types_2.ServiceType.OFFICE && { merchantId: profile.merchantId }),
        };
    }, [service, profile]);
    const isMd = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("md"));
    const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } = (0, react_hooks_1.useFetchQuery)(DISCRETE_URL, { enableInfiniteScroll: isMd }, void 0, initialSearchValues);
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { handleDelete } = (0, react_hooks_1.useDialogDelete)();
    const discreteGradeCreate = () => {
        openDialog(dialogs_1.GlobalDialogKeys.DISCRETE_CREATE, emptyValues, {
            refetch,
            initialValues: emptyValues,
            message: "dialogs.create",
            testId: "GradeDialogForm",
            filter: schemas_1.discreteCreateFilter,
            url: DISCRETE_URL,
            validationSchema: validation_1.discreteValidationSchema,
            componentProps: {
                mode: "create",
            },
        });
    };
    const discreteGradeEdit = (discrete) => () => {
        openDialog(dialogs_1.GlobalDialogKeys.DISCRETE_EDIT, discrete, {
            refetch,
            initialValues: discrete,
            message: "dialogs.edit",
            testId: "GradeDialogForm",
            url: `${DISCRETE_URL}/${discrete.id}`,
            validationSchema: validation_1.discreteValidationSchema,
            filter: schemas_1.discreteEditFilter,
            prepareInitialValues: schemas_1.prepareDiscreteInitialValues,
            componentProps: {
                mode: "edit",
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "discrete"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.discrete.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), onClick: discreteGradeCreate, "data-testid": "GradeCreateButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.create" }) }) }), (0, jsx_runtime_1.jsx)(mui_form_search_1.SearchWithFilters, { initialValues: initialSearchValues, children: (0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [service === types_2.ServiceType.OFFICE ? 2 : 1], children: [service === types_2.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(inputs_1.SearchMerchantInput, { disableClear: true }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { multiple: true, name: "discreteStatus", options: types_1.DiscreteStatus })] }) }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: allRows.length, isLoading: isLoading, children: allRows.map(grade => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemText, { children: [grade.contract?.title, " (", grade.attribute, ")"] }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: discreteGradeEdit(grade), message: "form.buttons.edit", dataTestId: "GradeEditButton", icon: icons_material_1.Create }), (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDelete(grade), message: "form.buttons.delete", dataTestId: "GradeDeleteButton", icon: icons_material_1.Delete, disabled: grade.discreteStatus === types_1.DiscreteStatus.INACTIVE })] })] }, grade.id))) }) }), !isMd && totalCount > take && ((0, jsx_runtime_1.jsx)(styled_1.StyledPagination, { shape: "rounded", page: skip / take + 1, count: Math.ceil(totalCount / take), onChange: onChangePage })), isMd && hasNextPage && (0, jsx_runtime_1.jsx)("div", { ref: loadMoreRef, style: { height: "20px", margin: "20px 0" } }), (0, jsx_runtime_1.jsx)(mui_dialog_delete_1.DeleteDialog, { url: DISCRETE_URL, refetch: refetch })] }));
};
exports.Discrete = Discrete;
//# sourceMappingURL=index.js.map